
import { isObject, isEmpty } from '@/utils/types';
import Emitter from 'element-ui/lib/mixins/emitter';

export default {
  // 自定义字段库 单选
  name: 'WkSelect',

  components: {},

  mixins: [Emitter],

  props: {
    value: [String, Number],
    // 选择其他展示input输入框
    otherShowInput: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    clearable: Boolean,
    placeholder: String,
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showType: {
      type: String,
      default: 'default' //  下拉 default 平铺 tiled
    }
  },

  data: function data() {
    return {
      dataValue: {
        select: '',
        otherValue: ''
      }
    };
  },


  computed: {
    valueIsObject: function valueIsObject() {
      return isObject(this.dataValue);
    }
  },

  watch: {
    value: {
      handler: function handler(newVal, oldVal) {
        this.validValue();
      },

      immediate: true
    }
  },

  created: function created() {
    // this.validValue()
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    /**
     * 验证值
     */
    validValue: function validValue() {
      var _this = this;

      if (this.value !== this.dataValue.select && this.value !== this.dataValue.otherValue) {
        if (isEmpty(this.value)) {
          this.dataValue = {
            select: '',
            otherValue: ''
          };
        } else {
          if (this.otherShowInput) {
            var valueObj = this.options.find(function (item) {
              return _this.getValue(item) === _this.value;
            });
            if (valueObj) {
              if (this.dataValue.select !== this.value) {
                this.dataValue = {
                  select: this.value,
                  otherValue: ''
                };
              }
            } else {
              if (this.dataValue.otherValue !== this.value) {
                this.dataValue = {
                  select: '其他',
                  otherValue: this.value
                };
              }
            }
          } else {
            this.dataValue = {
              select: this.value,
              otherValue: ''
            };
          }
        }
      }
    },


    /**
     * 选项值
     */
    getValue: function getValue(item) {
      return !this.isEmptyValue(item.value) ? item.value : item;
    },


    /**
     * 判断是空值
     */
    isEmptyValue: function isEmptyValue(value) {
      return value === null || value == undefined;
    },


    /**
     * 值更新
     */
    valueChange: function valueChange() {
      var value = this.dataValue.select === '其他' ? this.dataValue.otherValue.trim() : this.dataValue.select;
      this.$emit('input', value);
      this.$emit('change', value);
      this.dispatch('ElFormItem', 'el.form.change', value);
    },


    /**
     * 失去焦点
     */
    inputBlur: function inputBlur() {
      // 暂未加input触发change逻辑
      var value = this.dataValue.otherValue;
      var eIsObject = this.options.length > 0 && !this.isEmptyValue(this.options[0].value);
      var has = this.options.find(function (item) {
        if (eIsObject) {
          return item.value === value.trim();
        } else {
          return item === value.trim();
        }
      });
      if (has) {
        this.dataValue.otherValue = '';
      }

      this.$emit('input', this.dataValue.otherValue);
      this.$emit('change', this.dataValue.otherValue);
      this.dispatch('ElFormItem', 'el.form.change', this.dataValue.otherValue);
    }
  }
};